import { render } from "./MainPage.vue?vue&type=template&id=53182751&scoped=true&ts=true"
import script from "./MainPage.vue?vue&type=script&lang=ts"
export * from "./MainPage.vue?vue&type=script&lang=ts"

import "./MainPage.vue?vue&type=style&index=0&id=53182751&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53182751"]])

export default __exports__